export default "__VITE_ASSET__8dFX$hpz__"